var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6672 15.8328C10.8901 16.0557 11.2516 16.0557 11.4745 15.8328L14.2106 13.0967L16.9467 15.8328C17.1696 16.0557 17.5311 16.0557 17.754 15.8328C17.9769 15.6098 17.9769 15.2484 17.754 15.0255L15.0179 12.2894C14.572 11.8435 13.8491 11.8435 13.4033 12.2894L10.6672 15.0255C10.4443 15.2484 10.4443 15.6098 10.6672 15.8328Z",
    fill: "#1A1C1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpCircleWhite);
export default __webpack_public_path__ + "static/media/arrow-up-circle-white.c9fa94c77ebc50a2d5f05d8ab12cef11.svg";
export { ForwardRef as ReactComponent };